import { Star } from "lucide-react";

// half-star rating component, letterboxd-style
// value: number 0–5 in 0.5 increments
export default function StarRating({
  value = 0,
  onChange,
  size = 32,
  readOnly = false,
  className = "",
  showValue = false,
  testIdPrefix = "star",
}) {
  const setVal = (v) => {
    if (readOnly || !onChange) return;
    onChange(value === v ? 0 : v);
  };

  return (
    <div
      className={`flex items-center gap-0.5 ${className}`}
      data-testid={`${testIdPrefix}-rating`}
      data-value={value}
    >
      {[1, 2, 3, 4, 5].map((n) => {
        const halfVal = n - 0.5;
        const fullVal = n;
        const isFull = value >= fullVal;
        const isHalf = value >= halfVal && value < fullVal;

        return (
          <div
            key={n}
            className="relative"
            style={{ width: size, height: size }}
          >
            {/* base */}
            <Star
              className="absolute inset-0 text-white/20"
              style={{ width: size, height: size }}
              strokeWidth={1.5}
              fill="none"
            />
            {/* fill */}
            {(isFull || isHalf) && (
              <div
                className="absolute inset-0 overflow-hidden pointer-events-none"
                style={{ width: isFull ? "100%" : "50%" }}
              >
                <Star
                  className="text-acid"
                  style={{
                    width: size,
                    height: size,
                    fill: "#9cff00",
                    color: "#9cff00",
                  }}
                  strokeWidth={1.5}
                />
              </div>
            )}
            {/* click halves */}
            {!readOnly && (
              <>
                <button
                  type="button"
                  data-testid={`${testIdPrefix}-${n}-half`}
                  onClick={() => setVal(halfVal)}
                  className="absolute inset-y-0 left-0 w-1/2 z-10"
                  aria-label={`${halfVal} stars`}
                />
                <button
                  type="button"
                  data-testid={`${testIdPrefix}-${n}`}
                  onClick={() => setVal(fullVal)}
                  className="absolute inset-y-0 right-0 w-1/2 z-10"
                  aria-label={`${fullVal} stars`}
                />
              </>
            )}
          </div>
        );
      })}
      {showValue && value > 0 && (
        <span className="ml-2 font-mono text-xs text-acid tabular-nums">
          {value.toFixed(1)}
        </span>
      )}
    </div>
  );
}
